import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Bitte füllen Sie alle Felder aus.');
      setLoading(false);
      return;
    }

    try {
      const { error: signInError } = await signIn(email, password);
      
      if (signInError) {
        if (signInError.message?.includes('Invalid login credentials')) {
          setError('Ungültige Anmeldedaten. Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.');
        } else {
          setError(signInError.message || 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
        }
      }
    } catch (err) {
      setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/assets/images/wigbers_logo.svg" 
            alt="Wigbers Logo" 
            className="h-12 w-auto"
          />
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-lg border border-border p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-text-primary mb-2">
              Customer Hub
            </h1>
            <p className="text-text-secondary">
              Bitte melden Sie sich an, um fortzufahren
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              label="E-Mail-Adresse"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder="ihre.email@unternehmen.de"
              required
              error={error && !password ? error : ''}
              disabled={loading}
            />

            <Input
              label="Passwort"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Ihr Passwort"
              required
              error={error && password ? error : ''}
              disabled={loading}
            />

            {error && (
              <div className="flex items-center gap-2 p-3 bg-error/10 border border-error/20 rounded-lg text-sm text-error">
                <Icon name="AlertCircle" size={16} />
                <span>{error}</span>
              </div>
            )}

            <Button
              type="submit"
              variant="default"
              size="lg"
              fullWidth
              loading={loading}
              disabled={loading || !email || !password}
              iconName="LogIn"
              iconPosition="left"
            >
              Anmelden
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-border">
            <p className="text-xs text-center text-text-secondary">
              Bei Problemen wenden Sie sich bitte an Ihren Ansprechpartner.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
